import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/data';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroSlides.length;

  const next = useCallback(() => setCurrent((c) => (c + 1) % total), [total]);
  const prev = useCallback(() => setCurrent((c) => (c - 1 + total) % total), [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="w-full max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 mb-4 leading-tight">
            {heroSlides[current].title}
          </h1>
          <p className="text-base md:text-lg text-background-200 mb-8 max-w-2xl mx-auto">
            {heroSlides[current].subtitle}
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/category/pure-love"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md text-sm font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              探索分类
            </Link>
            <Link
              to="/article/japanese-adult-anime-culture-history"
              className="inline-flex items-center gap-2 bg-background-50/20 hover:bg-background-50/30 text-background-50 border border-background-50/30 px-6 py-3 rounded-md text-sm font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              了解文化史
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all ${
              i === current
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-950/30 hover:bg-background-950/50 text-background-50 transition-colors z-10"
        aria-label="Previous slide"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-950/30 hover:bg-background-950/50 text-background-50 transition-colors z-10"
        aria-label="Next slide"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </section>
  );
}